<template>
    <div>

        <form @submit.prevent="onSubmit" @keydown="form.errors.clear($event.target.name)" ref="form">

            <input type="hidden" name="stay-on-page" v-model="stayOnPage">

            <br><br><br>

            <div class="row">

                <div class="col-sm-6">

                    <div class="form-group">
                        <label for="display_name">Nazwa wyświetalna</label>
                        <input type="text" class="form-control" id="display_name" v-model="form.display_name" :disabled="language === 'default'">
                        <span class="error mt-2 text-danger" v-if="form.errors.has('display_name')" v-text="form.errors.get('display_name')"></span>
                    </div>

                    <div class="form-group" v-if="editorConfig.has_icon">
                        <label>Ikona</label>
                        <file-manager-image-select :input-name="'icon'" :value="form.icon" v-model="form.icon" :mime-types="'image/gif,image/jpeg,image/png,image/tiff,image/bmp,image/x-xbitmap'" :crop-available="true" :crop-aspect-ratio="1" :width="200" :disabled="language === 'default'"></file-manager-image-select>
                        <span class="error mt-2 text-danger" v-if="form.errors.has('icon')" v-text="form.errors.get('icon')"></span>
                    </div>

                </div>

                <div class="col-sm-2"></div>

                <div class="col-sm-4" v-if="language !== 'default'">
                    <p style="font-size: 0.875rem; line-height: 1; margin-bottom: 0.75rem !important;">Importuj dane z pliku rozdzielanego tabulaturą</p>
                    <quiz-import-csv :columns-count="columnDefs.length - 2" @load="prepareAndLoadData($event)"></quiz-import-csv>
                </div>

            </div>

            <br><br>

            <div class="row">
                <div class="col-sm-6 col-md-8 col-lg-10">
                    <a href="javascript:void(0);" class="btn btn-sm btn-primary" v-if="language !== 'default'" @click="addRow">Dodaj wiersz</a>
                    <a href="javascript:void(0);" class="btn btn-sm btn-danger" v-if="language !== 'default'" @click="removeSelectedRows">Usuń wiersze</a>
                </div>
                <div class="col-sm-6 col-md-4 col-lg-2">
                    <input type="text" class="form-control form-control-sm" placeholder="Szukaj" v-model="filterInput" @input="applyFilter">
                </div>
            </div>

            <br>

            <ag-grid-vue style="width: 100.06%; height: 500px;"
                         class="ag-theme-balham"
                         :gridOptions="gridOptions"
                         @model-updated="onModelUpdated"
                         @row-drag-end="onRowDragEnd"
                         :columnDefs="columnDefs"
                         :defaultColDef="defaultColDef"
                         v-model="rowData"
                         :suppressRowClickSelection="true"
                         :rowSelection="rowSelection"
                         :rowDragManaged="true"
                         :animateRows="true"
                         :getRowNodeId="getRowNodeId">
            </ag-grid-vue>

        </form>

    </div>
</template>

<script>

    import {AgGridVue} from 'ag-grid-vue';
    import Image from "../../../../../../../FileManager/Resources/assets/js/classes/Image";

    export default {
        name: 'QuizEditFileComponent',
        props: [
            'game',
            'gameFileData',
            'token',
            'editorConfig',
            'language'
        ],
        data() {
            return {
                eventHub: window.eventHub,
                gridOptions: null,
                gridApi: null,
                columnApi: null,
                defaultColDef: null,
                columnDefs: null,
                rowData: null,
                rowSelection: null,
                filterInput: null,
                form: new Vue.prototype.Form({
                    display_name: this.gameFileData.display_name,
                    icon: new Image(this.gameFileData.icon),
                    content: null
                }),
                stayOnPage: false
            };
        },
        components: {
            AgGridVue
        },
        beforeMount() {

            // Build column defs
            this.columnDefs = [];

            if (this.language !== 'default') {
                this.columnDefs.push({
                    headerName: '',
                    lockPosition: true,
                    cellClass: 'locked-col',
                    width: 35,
                    suppressSizeToFit: true,
                    resizable: false,
                    suppressNavigable: true,
                    rowDrag: true,
                    valueGetter: (params) => {
                        return params.data.question;
                    }
                });
                this.columnDefs.push({
                    headerName: '',
                    lockPosition: true,
                    cellClass: 'locked-col',
                    width: 40,
                    suppressSizeToFit: true,
                    resizable: false,
                    suppressNavigable: true,
                    headerCheckboxSelection: true,
                    headerCheckboxSelectionFilteredOnly: true,
                    checkboxSelection: true,
                });
            }

            this.columnDefs.push({
                headerName: 'Pytanie',
                field: 'question',
                resizable: true,
                sortable: true,
                filter: true,
                cellRenderer: function(param) {
                    return param.value.replace(/[\r\n]/g, '•')
                },
                editable: this.language !== 'default',
                cellEditor: 'agLargeTextCellEditor',
                cellEditorParams: {
                    maxLength: 1000,
                    rows: 4,
                    cols: 60
                }
            });

            // Tips columns defs
            if (this.editorConfig.hasOwnProperty('tips') && this.editorConfig.tips > 0) {
                for (let i = 1; i <= this.editorConfig.tips; i++) {
                    this.columnDefs.push({
                        headerName: 'Podpowiedź ' + i,
                        field: 'tip-' + i,
                        resizable: true,
                        sortable: true,
                        filter: true,
                        cellRenderer: function(param) {
                            return param.value.replace(/[\r\n]/g, '•')
                        },
                        editable: this.language !== 'default',
                        cellEditor: 'agLargeTextCellEditor',
                        cellEditorParams: {
                            maxLength: 1000,
                            rows: 4,
                            cols: 60
                        }
                    });
                }
            }

            this.columnDefs.push({
                headerName: 'Poprawna odpowiedź',
                field: 'correct-answer',
                resizable: true,
                sortable: true,
                filter: true,
                cellRenderer: function(param) {
                    return param.value.replace(/[\r\n]/g, '•')
                },
                editable: this.language !== 'default',
                cellEditor: 'agLargeTextCellEditor',
                cellEditorParams: {
                    maxLength: 1000,
                    rows: 4,
                    cols: 60
                }
            });

            // Incorrect answers columns defs
            if (this.editorConfig.hasOwnProperty('answers') && this.editorConfig.answers > 0) {
                for (let i = 1; i < this.editorConfig.answers; i++) {
                    this.columnDefs.push({
                        headerName: 'Niepoprawna odpowiedź ' + i,
                        field: 'incorrect-answer-' + i,
                        resizable: true,
                        sortable: true,
                        filter: true,
                        cellRenderer: function(param) {
                            return param.value.replace(/[\r\n]/g, '•')
                        },
                        editable: this.language !== 'default',
                        cellEditor: 'agLargeTextCellEditor',
                        cellEditorParams: {
                            maxLength: 1000,
                            rows: 4,
                            cols: 60
                        }
                    });
                }
            }

            this.gridOptions = {
                deltaRowDataMode: true
            };

            this.rowSelection = 'multiple';

            fetch(route('game::game-editor.get-file-content', {token: this.token, language: this.language, name: this.gameFileData.name}))
                .then(result => result.json())
                .then(rowData => {
                    this.prepareAndLoadData(rowData.data);
                });
        },

        created () {
            this.eventHub.$on('submit-form', (stay) => {
                this.stayOnPage = stay;
                this.onSubmit();
            })
        },

        beforeDestroy () {
            this.eventHub.$off('submit-form')
        },

        mounted() {
            this.gridApi = this.gridOptions.api;
            this.gridColumnApi = this.gridOptions.columnApi;
        },

        methods: {

            getRowNodeId(data) {
                return data.id;
            },

            onModelUpdated() {
                if (this.gridOptions.api && this.columnDefs) {
                    this.gridOptions.api.sizeColumnsToFit();
                }
            },

            onRowDragEnd(event) {
                let updatedRowData = [];
                this.gridOptions.api.forEachNode(function(node) {
                    updatedRowData.push(node.data);
                });
                this.rowData = updatedRowData;
            },

            applyFilter() {
                this.gridOptions.api.setQuickFilter(this.filterInput);
            },

            removeSelectedRows() {
                let selectedRowData = this.gridApi.getSelectedRows();
                this.gridOptions.api.updateRowData({remove: selectedRowData});
            },

            addRow() {

                // Build new row object
                let newRow = {
                    id: Math.floor(new Date().valueOf() * Math.random()),
                    question: '',
                    correct_answer: '',
                };

                // Add incorrect answers fields to new row object
                if (this.editorConfig.hasOwnProperty('answers') && this.editorConfig.answers > 0) {
                    for (let i = 1; i < this.editorConfig.answers; i++) {
                        newRow['incorrect-answer-' + i] = '';
                    }
                }

                // Add tips tips fields to new row object
                if (this.editorConfig.hasOwnProperty('tips') && this.editorConfig.tips > 0) {
                    for (let i = 1; i <= this.editorConfig.tips; i++) {
                        newRow['tip-' + i] = '';
                    }
                }

                this.gridOptions.api.updateRowData({add: [newRow]});
            },

            onSubmit() {
                let rows = this.rowData;
                rows.forEach(x => {delete x.id});
                this.form.content = rows;
                this.form.put(route('game::game-editor.save-file', {gameId: this.game.id, token: this.token, language: this.language, name: this.gameFileData.name}))
                    .then(response => {
                        if (this.stayOnPage) {
                            this.form.icon = new Image(response.data.iconUrl);
                            this.eventHub.$emit('processing-finish');
                            this.eventHub.$emit('toast-notification', response.message, 'success');
                        } else {
                            window.location.href = route('game::game-editor.list-files', {gameId: this.game.id, token: this.token, language: this.language}) + '?status-message=success:' + response.message;
                        }
                    })
                    .catch(response => {
                        this.eventHub.$emit('processing-finish');
                        this.eventHub.$emit('toast-notification', 'Coś poszło nie tak. Sprawdź poprawność danych.', 'error');
                    });
            },

            prepareAndLoadData(data) {
                let newRowData = [];
                let columnDefs = this.columnDefs.slice(0); // clone array
                if (this.language !== 'default') {
                    columnDefs.shift();
                    columnDefs.shift();
                }
                data.forEach((row) => {
                    let newRowItem = {};
                    let i = 0;
                    columnDefs.forEach((colDef) => {
                        newRowItem[colDef.field] = row[i];
                        i++;
                    });
                    newRowData.push(newRowItem);
                });
                newRowData.forEach((data, index) => {
                    data.id = index;
                });
                this.rowData = newRowData;
            }
        }
    }
</script>

<style scoped>

</style>
